import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    type: "week",
    weekday: [1, 2, 3, 4],
    data: [],
    loading: false,
    lastSync: null,
    syncError: null,
    user: Cookies.get("user") || "",
    isAdmin: Cookies.get("is_admin") === "true",
  },
  getters: {
    preprocessed: (state) => () => {
      if (state.data && state.data.length > 0) {
        return state.data.map((i) => {
          return {
            name: i.name ? i.name : i.event,
            event: i.event,
            start: i.start,
            end: i.end,
            color: i.color,
          }
        })
      } else {
        return [];
      }
    }
  },
  mutations: {
  },
  actions: {
    async fetch({state}) {
      state.loading = true;
      try {
        const data = await axios.get("/api/get")
        state.data = data.data;
        const syncHeader = data.headers['x-last-sync'];
        if (syncHeader) state.lastSync = new Date(syncHeader);
      } finally {
        state.loading = false;
      }
    },

    async sync({state}) {
      state.loading = true;
      try {
        const res = await axios.post("/api/sync", null, { params: { user: state.user } })
        state.data = res.data;
        state.lastSync = new Date();
        state.syncError = null;
      } catch (e) {
        if (e.response && e.response.status === 429) {
          const retry = e.response.data.retry_after;
          state.syncError = `Sync wird abgekühlt. Erneut versuchen in ${Math.ceil(retry / 60)} Min.`;
          // Still load cached data on 429 if the response has it
          if (Array.isArray(e.response.data)) {
            state.data = e.response.data;
            state.lastSync = new Date();
          }
        } else {
          state.syncError = "Sync fehlgeschlagen. Bitte erneut versuchen.";
        }
        throw e;
      } finally {
        state.loading = false;
      }
    }
  },
  modules: {
  }
})
